export const REFEREE_RELATIONSHIPS = [
  { value: 'MANAGED_DIRECTLY' as const, label: 'Managed directly' },
  { value: 'REPORTED_DIRECTLY' as const, label: 'Reported directly to me' },
  { value: 'WORKED_SAME_TEAM' as const, label: 'Worked on the same team' },
  { value: 'WORKED_CROSS_FUNCTIONALLY' as const, label: 'Worked cross-functionally' },
  { value: 'OCCASIONALLY_COLLABORATED' as const, label: 'Occasionally collaborated' },
  { value: 'WAS_DIRECT_SUBORDINATE' as const, label: 'Was a direct subordinate' },
  { value: 'WAS_CLIENT' as const, label: 'Was a client' },
  { value: 'WAS_SERVICE_PROVIDER' as const, label: 'Was a service provider' },
  { value: 'WAS_MENTORED' as const, label: 'Was mentored by me' },
  { value: 'ACTED_AS_MENTOR' as const, label: 'Acted as my mentor' },
  { value: 'ACADEMIC_ADVISOR' as const, label: 'Academic advisor' },
  {
    value: 'WORKED_SAME_COMPANY_DIFFERENT_TEAMS' as const,
    label: 'Worked at same company, different teams',
  },
] as const;
